import { compose, filter, map, pathEq, prop } from 'ramda'

export const getSelectedPlacesValues = (values, type) => {
  const filteredValues = compose(
    map(prop('label')),
    filter(item => !type || pathEq(['origin', 'type'], type, item))
  )(values)

  if (!filteredValues) return values
  if (filteredValues.length > 5 || filteredValues.some(item => !item)) {
    return `${filteredValues.length} selecionados`
  }

  return filteredValues.join(', ')
}
